import Typography from '@/components/typography';
import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { type ComponentProps } from 'react';

const bodyStyles = cva('text-black', {
  variants: {
    variant: {
      body1: 'text-2xl font-light', //24px
      body2: 'text-base', //16px
      body3: 'text-sm', //14px
      body4: 'text-xs', //12px
      body5: 'text-xxs', //11px
      body6: 'text-xxxs', //10px
    },
  },
});

type TypographyProps = ComponentProps<typeof Typography>;
type Props = VariantProps<typeof bodyStyles> & Omit<TypographyProps, 'classNames'> & { className?: string };

export const Body = ({ children, variant, className, ...props }: Props) => (
  <Typography classNames={cn(bodyStyles({ variant }), className)} {...props}>
    {children}
  </Typography>
);
